export const viewQueryKeys = {
  view: {
    all: () => ['view'] as const,
    details: (viewId: number) => ['view', 'details', viewId] as const,
    list: (roadmapId: number) => ['view', 'list', roadmapId] as const,
  },
  filter: {
    list: (viewId: number) => ['filters', viewId],
    detail: (viewId: number, fieldId: string) => ['filter', viewId, fieldId],
  },
  publishedView: {
    detail: (viewId: number) => ['published-view', viewId] as const,
  },
};
